import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=78828a54&scoped=true"
import script from "./CartList.vue?vue&type=script&lang=ts"
export * from "./CartList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78828a54",
  null
  
)

export default component.exports